
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/email-unsubscribe",
      function () {
        return require("private-next-pages/email-unsubscribe/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/email-unsubscribe"])
      });
    }
  